
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trova-agente",
      function () {
        return require("private-next-pages/trova-agente/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trova-agente"])
      });
    }
  